<template>
  <div>
    <div class="t_header" v-if="w_width<888">
      <div class="fx_cs t_topbar">
        <img src="../assets/img/homepage/logotop.png" style="height: 28px" />
        <i class="iconfont iconzu1714" style="color: #FFFFFF" @click="change()"></i>
      </div>
      <div class="t_s_title">
        <img src="../assets/img/1659.jpg" style="width: 100%">
        <div class="t_s_txt">
          <span class="ausp1" style="font-size: 32px;padding: 0">服务与支持</span>
          <span class="ausp2" style="font-size: 30px">SERVICE</span>
        </div>
      </div>
    </div>
    <div class="header" v-else>
      <div class="topbar">
        <img src="../assets/img/homepage/logotop.png" />
        <myheader></myheader>
      </div>
      <div class="widtol mesdiv1">
        <div class="audiv1">
          <span class="ausp1">服务与支持</span>
          <span class="ausp2">SERVICE</span>
        </div>
      </div>
    </div>
    <div v-if="w_width<888">
      <div style="background: #FFF">
        <div style="padding: 40px 0">
          <div class="t_s_txt3">服务优势</div>
          <div class="t_s_txt2">
            专业化团队，实时化响应，可视化流程<br>一站式服务，全方位满足您的需求
          </div>
          <div class="t_s_seritem" v-for="(item,index) in advances" :key="index">
            <div>
              <img :src="item.img" style="width: 100%">
            </div>
            <div class="serdiv3" style="padding: 15px 0">
              <div class="t_s_sersp1">{{item.title}}</div>
              <div class="t_s_sersp2">{{item.detail1}}</div>
              <div class="t_s_sersp2">{{item.detail2}}</div>
              <div class="t_s_sersp2">{{item.detail3}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="t_bcgray" style="padding: 37px 0">
        <div class="t_s_txt3">服务流程</div>
        <div class="t_txt8" style="margin: 15px 0 25px 0">无缝对接、专业服务流程</div>
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="t_txt4">阶段一：需求确认</div>
              <img src="../assets/img/homepage/c1.jpg" style="width: 100%;margin: 40px 0 8px 0">
              <div class="fx_cs">
                <div>
                  <div class="t_icon4">
                    <div class="t_maindiv21">
                      <i class="iconfont iconzu1260 mainicon"></i>
                    </div>
                    <span class="t_txt7">需求调研</span>
                  </div>
                  <div class="t_icon4">
                    <div class="t_maindiv21">
                      <i class="iconfont iconzu1261 mainicon"></i>
                    </div>
                    <span class="t_txt7">合同签订</span>
                  </div>
                </div>
                <div>
                  <div class="t_icon4">
                    <div class="t_maindiv21">
                      <i class="iconfont iconzu1259 mainicon"></i>
                    </div>
                    <span class="t_txt7">方案及预算</span>
                  </div>
                  <div class="t_icon4">
                    <div class="t_maindiv21">
                      <i class="iconfont iconlujing3280 mainicon"></i>
                    </div>
                    <span class="t_txt7">制定项目计划</span>
                  </div>
                </div>
              </div>
              <div class="t_icon4">
                <div class="t_maindiv21">
                  <i class="iconfont iconlujing3280 mainicon"></i>
                </div>
                <span class="t_txt7">制定项目计划</span>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="t_txt4">阶段二：项目研发</div>
              <img src="../assets/img/homepage/c2.jpg" style="width: 100%;margin: 40px 0 8px 0">
              <div class="fx_cs">
                <div class="t_icon4">
                  <div class="t_maindiv21">
                    <i class="iconfont iconlujing3279 mainicon"></i>
                  </div>
                  <span class="t_txt7">功能研发</span>
                </div>
                <div class="t_icon4">
                  <div class="t_maindiv21">
                    <i class="iconfont iconzu1258 mainicon"></i>
                  </div>
                  <span class="t_txt7">项目测试</span>
                </div>
              </div>
              <div class="t_txt8">
                每周输出项目进度报告<br>帮助客户实时了解研发进度
              </div>
            </div>
            <div class="swiper-slide">
              <div class="t_txt4">阶段三：交付验收</div>
              <img src="../assets/img/homepage/c3.jpg" style="width: 100%;margin: 40px 0 8px 0">
              <div class="fx_cs">
                <div class="t_icon4">
                  <div class="t_maindiv21">
                    <i class="iconfont iconlujing3281 mainicon"></i>
                  </div>
                  <span class="t_txt7">实施交付</span>
                </div>
                <div class="t_icon4">
                  <div class="t_maindiv21">
                    <i class="iconfont iconzu1263 mainicon"></i>
                  </div>
                  <span class="t_txt7">使用培训</span>
                </div>
              </div>
              <div class="t_txt8">
                根据阶段一的功能设计书进行功能验收<br>验收条目清晰可查
              </div>
            </div>
            <div class="swiper-slide">
              <div class="t_txt4">阶段四：运维支持</div>
              <img src="../assets/img/homepage/c4.jpg" style="width: 100%;margin: 40px 0 8px 0">
              <div class="fx_cs">
                <div class="t_icon4">
                  <div class="t_maindiv21">
                    <i class="iconfont iconlujing3283 mainicon"></i>
                  </div>
                  <span class="t_txt7">专属客户<br>经理对接</span>
                </div>
                <div class="t_icon4">
                  <div class="t_maindiv21">
                    <i class="iconfont iconlujing3282 mainicon"></i>
                  </div>
                  <span class="t_txt7">工作日<br>24小时响应</span>
                </div>
              </div>
              <div class="t_txt8">
                将反馈内容登记到课题表<br>每周进行跟进汇报
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex;position: relative;">
        <img src="../assets/img/1660.jpg" style="width: 100%">
        <div class="t_s_txt" style="color: #FFF;padding: 0 7.5%">
          <div style="font-size: 26px">交互原型设计</div>
          <div style="font-size: 13px;line-height: 1.4;margin: 25px 0">
            在项目进入研发阶段前，我们会提供详尽的UI画面设计及交互原型设计，清晰的体现画面细节、交互逻辑。<br>在客户确认后，以交互原型为标准进行代码开发，所见即所得，避免前后不一致
          </div>
          <div class="t_s_serdiv">
            <i class="iconfont iconzu866" style="font-size: 50px"></i>
            <div>精准匹配需求</div>
          </div>
          <div class="t_s_serdiv">
            <i class="iconfont iconzu867" style="font-size: 50px"></i>
            <div >交互逻辑清晰</div>
          </div>
          <div class="t_s_serdiv">
            <i class="iconfont iconzu868" style="font-size: 42px"></i>
            <div>所见即所得</div>
          </div>
        </div>
      </div>
      <div class="bcgray" style="padding: 50px 7.5%">
        <div class="t_s_txt3">功能设计书</div>
        <div class="t_s_txt2">
          为了清晰化、规范化项目流程，我们会为您提供功能设计书，详尽的定义各功能点及画面细节。<br>功能设计书需由客户签字确认，并在最终项目交付时用于核对功能及画面
        </div>
        <img style="width:100%;margin-top: 15px" src="../assets/img/30.png">
        <div class="t_s_serdiv12 serdiv12">
          <i class="iconfont iconlujing2468"></i>
          <span class="sersp8" style="font-size: 18px">画面项目</span>
        </div>
        <div class="t_s_serdiv12 serdiv12">
          <i class="iconfont iconlujing2462"></i>
          <span class="sersp8" style="font-size: 18px">UI设计</span>
        </div>
        <div class="t_s_serdiv12 serdiv12">
          <i class="iconfont iconlujing2461"></i>
          <span class="sersp8" style="font-size: 18px">业务逻辑</span>
        </div>
        <div class="t_s_serdiv12 serdiv12">
          <i class="iconfont iconzu923"></i>
          <span class="sersp8" style="font-size: 18px">交互跳转</span>
        </div>
        <div class="t_s_txt3" style="margin-top: 90px">售后服务</div>
        <div class="t_s_txt2">
          我们的全体工作人员严格按照服务标准竭诚为您提供全面服务，同时也希望得到您的支持与监督
        </div>
        <div class="t_s_serdiv14">
          <div>
            <i class="iconfont iconlujing2471" style="font-size: 48px;"></i>
            <div>现场服务</div>
          </div>
          <div>
            行业管理经验丰富的项目成员细致深入调研需求，出具交互原型设计图，所见即所得
          </div>
        </div>
        <div class="t_s_serdiv14">
          <div>
            <i class="iconfont iconzu924" style="font-size: 48px;"></i>
            <div>远程服务</div>
          </div>
          <div>
            简单问题，通过远程技术手段迅速指导解决，无需等待
          </div>
        </div>
        <div class="t_s_serdiv14">
          <div>
            <i class="iconfont iconzu925" style="font-size: 48px;"></i>
            <div>实施服务</div>
          </div>
          <div>
            专属技术实施团队保障系统顺利上线运行
          </div>
        </div>
        <div class="t_s_serdiv14">
          <div>
            <i class="iconfont iconzu1263" style="font-size: 48px;"></i>
            <div>培训服务</div>
          </div>
          <div>
            系统实施上线后，培训讲师提供系统使用手册，并现场进行操作培训和指导，让您随时学会使用
          </div>
        </div>
        <div class="t_s_serdiv14" style="border: 0">
          <div>
            <i class="iconfont iconlujing2476" style="font-size: 48px;"></i>
            <div>维护服务</div>
          </div>
          <div>
            系统可以设置定时自动备份，专业维护团队及技术团队定期维护检查，让系统软件运行无忧
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="bgwhite">
        <div class="widtol maindiv13">
          <span class="mainsp8" style="margin-bottom:18px">服务优势</span>
          <span class="mainsp9" style="font: normal normal normal 20px/32px Microsoft YaHei;">专业化团队，实时化响应，可视化流程，一站式服务，全方位满足您的需求</span>
          <div class="serdiv1">
            <div class="seritem" v-for="(item,index) in advances" :key="index">
              <div class="serdiv2">
                <img :src="item.img" class="serimg">
              </div>
              <div class="serdiv3">
                <span class="sersp1">{{item.title}}</span>
                <span class="sersp2">{{item.detail1}}</span>
                <span class="sersp2">{{item.detail2}}</span>
                <span class="sersp2">{{item.detail3}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bcgray ">
        <div class="widtol maindiv13">
          <span class="mainsp8" style="margin-bottom:18px">服务流程</span>
          <span class="mainsp9" style="font: normal normal normal 20px/32px Microsoft YaHei;">无缝对接、专业服务流程</span>
          <div class="maindiv14">
            <div v-for="(show,idx) in shows" :key="idx">
              <div class="maindiv15" @click="addclass(idx)" :class="selectedshow == idx ?'selected':''">
                <img :src="show.img">
              </div>
              <span class="mainsp11">{{show.content}}</span>
            </div>
          </div>
          <!-- 需求确认 -->
          <div class="maindiv16" v-show="selectedshow == '0'">
            <div class="maindiv17">
              <div class="maindiv18">
                <img src="../assets/img/homepage/c1.jpg">
              </div>
              
              <div class="maindiv19">
                <el-row class="maindiv20">
                  <el-col :span="10">
                    <div class="maindiv22">
                      <div class="maindiv21">
                        <i class="iconfont iconzu1260 mainicon"></i>
                      </div>
                      <span class="mainsp12">需求调研</span>
                    </div>
                  </el-col>
                  <el-col :span="2">
                    <i class="el-icon-arrow-right mainicon1"></i>
                  </el-col>
                  <el-col :span="9" :push="3">
                    <div class="maindiv22">
                      <div class="maindiv21">
                        <i class="iconfont iconzu1259 mainicon"></i>
                      </div>
                      <span class="mainsp12">方案及预算</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row  class="maindiv20">
                  <el-col :span="10">
                    <div class="maindiv22">
                      <div class="maindiv21">
                        <i class="iconfont iconzu1261 mainicon"></i>
                      </div>
                      <span class="mainsp12">合同签订</span>
                    </div>
                  </el-col>
                  <el-col :span="2">
                    <i class="el-icon-arrow-right mainicon1"></i>
                  </el-col>
                  <el-col :span="9" :push="3">
                    <div class="maindiv22">
                      <div class="maindiv21">
                        <i class="iconfont iconlujing3280 mainicon"></i>
                      </div>
                      <span class="mainsp12">制定项目计划</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row  class="maindiv20">
                  <el-col :span="24">
                    <div class="maindiv22">
                      <div class="maindiv21">
                        <i class="iconfont iconzu1262 mainicon"></i>
                      </div>
                      <span class="mainsp12">交互设计书 / 功能设计书</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <!-- 项目研发 -->
          <div class="maindiv16" v-show="selectedshow == '1'">
            <div class="maindiv17">
              <div class="maindiv18">
                <img src="../assets/img/homepage/c2.jpg">
              </div>
              
              <div class="maindiv19">
                <el-row class="maindiv20">
                  <el-col :span="10">
                    <div class="maindiv22">
                      <div class="maindiv21">
                        <i class="iconfont iconlujing3279 mainicon"></i>
                      </div>
                      <span class="mainsp12">功能研发</span>
                    </div>
                  </el-col>
                  <el-col :span="2">
                    <i class="el-icon-arrow-right mainicon1"></i>
                  </el-col>
                  <el-col :span="9" :push="3">
                    <div class="maindiv22">
                      <div class="maindiv21">
                        <i class="iconfont iconzu1258 mainicon"></i>
                      </div>
                      <span class="mainsp12">项目测试</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row  class="maindiv20">
                  <el-col :span="24" style="padding:0 10px">
                    <span class="mainsp13">在项目研发阶段，每周输出项目进度报告，帮助客户实时<br>了解研发进度</span>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <!-- 交付验收 -->
          <div class="maindiv16" v-show="selectedshow == '2'">
            <div class="maindiv17">
              <div class="maindiv18">
                <img src="../assets/img/homepage/c3.jpg">
              </div>
              
              <div class="maindiv19">
                <el-row class="maindiv20">
                  <el-col :span="10">
                    <div class="maindiv22">
                      <div class="maindiv21">
                        <i class="iconfont iconlujing3281 mainicon"></i>
                      </div>
                      <span class="mainsp12">实施交付</span>
                    </div>
                  </el-col>
                  <el-col :span="2">
                    <i class="el-icon-arrow-right mainicon1"></i>
                  </el-col>
                  <el-col :span="9" :push="3">
                    <div class="maindiv22">
                      <div class="maindiv21">
                        <i class="iconfont iconzu1263 mainicon"></i>
                      </div>
                      <span class="mainsp12">使用培训</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row  class="maindiv20">
                  <el-col :span="24" style="padding:0 10px">
                    <span class="mainsp13">在实施交付阶段，根据阶段一的功能设计书进行<br>功能验收，验收条目清晰可查</span>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <!-- 运维支持 -->
          <div class="maindiv16" v-show="selectedshow == '3'">
            <div class="maindiv17">
              <div class="maindiv18">
                <img src="../assets/img/homepage/c4.jpg">
              </div>
              
              <div class="maindiv19">
                <el-row class="maindiv20">
                  <el-col :span="12">
                    <div class="maindiv22">
                      <div class="maindiv21">
                        <i class="iconfont iconlujing3283 mainicon"></i>
                      </div>
                      <span class="mainsp12">专属客户经理对接</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="maindiv22">
                      <div class="maindiv21">
                        <i class="iconfont iconlujing3282 mainicon"></i>
                      </div>
                      <span class="mainsp12">工作日24小时响应</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row  class="maindiv20">
                  <el-col :span="24" style="padding:0 10px">
                    <span class="mainsp13">在实施交付阶段，根据阶段一的功能设计书进行功能验收，验收条目清晰可查</span>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="serdiv4">
        <div class="widtol ">
          <span class="sersp3">交互原型设计</span>
          <span class="sersp4">在项目进入研发阶段前，我们会提供详尽的UI画面设计及交互原型设计，清晰的体现画面细节、交互逻辑。<br>
           在客户确认后，以交互原型为标准进行代码开发，所见即所得，避免前后不一致。</span>
        </div>
        <div class="widtol serdiv5">
          <div class="serdiv6">
            <div class="serdiv8"></div>
            <div class="serdiv7">
              <i class="iconfont iconzu866"></i>
              <span class="sersp5">精准匹配<br>需求</span>
            </div>
          </div>

          <div class="serdiv6">
            <div class="serdiv8"></div>
            <div class="serdiv7">
              <i class="iconfont iconzu867"></i>
              <span class="sersp5">交互逻辑<br>清晰</span>
            </div>
          </div>

          <div class="serdiv6">
            <div class="serdiv8"></div>
            <div class="serdiv7">
              <i class="iconfont iconzu868"></i>
              <span class="sersp5">所见即 <br>所得</span>
            </div>
          </div>
        </div>
      </div>
      <div class="bcgray">
        <div class="widtol serdiv9">
          <span class="sersp6">功能设计书</span>
          <span class="sersp7">为了清晰化、规范化项目流程，我们会为您提供功能设计书，详尽的定义各功能点及画面细节。<br>
           功能设计书需由客户签字确认，并在最终项目交付时用于核对功能及画面。</span>
           <div class="serdiv10">
             <div style="width:50%">
               <div class="serdiv11">
                 <div class="serdiv12" style="margin-right:120px">
                   <i class="iconfont iconlujing2468"></i>
                   <span class="sersp8">画面项目</span>
                 </div>
                 <div class="serdiv12">
                   <i class="iconfont iconlujing2462"></i>
                   <span class="sersp8">U I 设计</span>
                 </div>
                 <div class="serdiv12" style="margin-right:120px;margin-top:50px">
                   <i class="iconfont iconlujing2461"></i>
                   <span class="sersp8">业务逻辑</span>
                 </div>
                 <div class="serdiv12" style="margin-top:50px">
                   <i class="iconfont iconzu923"></i>
                   <span class="sersp8">交互跳转</span>
                 </div>
               </div>
             </div>
             <div style="width:50%">
               <img style="width:495px;height:342px" src="../assets/img/30.png">
             </div>
           </div>
        </div>
      </div>
      <div class="bcwhite">
        <div class="widtol maindiv13" style="padding-bottom:120px">
          <span class="mainsp8" style="margin-bottom:18px">售后服务</span>
          <span class="mainsp9" style="font: normal normal normal 20px/32px Microsoft YaHei;">我们的全体工作人员严格按照服务标准竭诚为您提供全面服务，同时也希望得到您的支持与监督</span>
          <div class="serdiv13">
            <div class="serdiv14">
              <i class="iconfont iconlujing2471"></i>
              <span class="sersp9">现场服务</span>
              <span class="sersp10">行业管理经验丰富的项目成员细致深入<br>
              调研需求，出具交互原型设计图，所见<br>
              即所得</span>
            </div>

            <div class="serdiv14">
              <i class="iconfont iconzu924"></i>
              <span class="sersp9">远程服务</span>
              <span class="sersp10">简单问题，通过远程技术手段<br>迅速指导解决，无需等待</span>
            </div>

            <div class="serdiv14">
              <i class="iconfont iconzu925"></i>
              <span class="sersp9">实施服务</span>
              <span class="sersp10">专属技术实施团队<br>保障系统顺利上线运行</span>
            </div>
          </div>
          <div class="serdiv13" style="width:714px;margin:0 auto;">
            <div class="serdiv14">
              <i class="iconfont iconzu1263"></i>
              <span class="sersp9">培训服务</span>
              <span class="sersp10">系统实施上线后，培训讲师提供系统使用<br>手册，并现场进行操作培训和指导，让您<br>随时学会使用</span>
            </div>

            <div class="serdiv14">
              <i class="iconfont iconlujing2476"></i>
              <span class="sersp9">维护服务</span>
              <span class="sersp10">
                系统可以设置定时自动备份，专业维护<br>团队及技术团队定期维护检查，<br> 让系统软件运行无忧
              </span>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!---首页弹出----->
    <mt-popup
      v-model="boxShow"
      position="right">
      <div style="display: block;padding: 40px 7%;" :style="{width:w_width+'px',height:w_height+'px'}">
        <div style="text-align: right">
          <span style="font-size: 25px" @click="boxShow=false">✕</span>
        </div>
        <div class="t_list" @click="goto('/#')">首页</div>
        <div class="t_list fx_cs" @click="listShow=true">
          TMIP产品体系
          <i class="iconfont iconlujing3278 t_icon2"></i>
        </div>
        <div v-show="listShow">
          <div class="t_t_list" @click="goto('/mes')">MES 生产管理</div>
          <div class="t_t_list" @click="goto('/wms')">WMS 智慧仓储</div>
          <div class="t_t_list" @click="goto('/mtr')">MTR 物料溯源</div>
          <div class="t_t_list" @click="goto('/emv')">EMV 生产可视化</div>
        </div>
        <div class="t_list" @click="boxShow=false">服务与支持</div>
        <div class="t_list" style="border: 0" @click="goto('/aboutus')">关于我们</div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import util from "../components/util";
import Swiper from "swiper";
export default util.useCommon({
  data() {
    return {
       selectedshow:'0',
       shows: [
        {
          img:require('../assets/img/homepage/b1.png'),
          content:'需求确认'
        },
        {
          img:require('../assets/img/homepage/b2.png'),
          content:'项目研发'
        },
        {
          img:require('../assets/img/homepage/b3.png'),
          content:'交付验收'
        },
        {
          img:require('../assets/img/homepage/b4.png'),
          content:'运维支持'
        },
      ],
      advances:[
        {
          img:require('../assets/img/26.png'),
          title:'专业',
          detail1:'5大团队',
          detail2:'经验丰富',
          detail3:'流程标准',
        },
        {
          img:require('../assets/img/27.png'),
          title:'快捷',
          detail1:'7*24小时',
          detail2:'实时响应',
          detail3:'沟通无碍',
        },
        {
          img:require('../assets/img/28.png'),
          title:'高效',
          detail1:'流程简捷',
          detail2:'无缝衔接',
          detail3:'快速解决',
        },
        {
          img:require('../assets/img/29.png'),
          title:'专业',
          detail1:'专线监督',
          detail2:'定期回访',
          detail3:'过程透明',
        }
      ],
      w_width:0,
      boxShow: false,
      listShow:true,
      w_height:0
    };
  },
  watch: {
  },
  methods: {  
    addclass(idx){
      var v = this;
      v.selectedshow = idx;
    },
    change(){
      this.boxShow = true;
      console.log(this.boxShow);
    },
    goto(add) {
      this.backtop();
      this.$router.push(add);
    },
    backtop() {
      this.$emit('gotoTop');
    }
  },
  mounted() {
    this.w_width = window.innerWidth;
    console.log(this.w_width);
    this.w_height = window.innerHeight;
    var swiper = new Swiper('.swiper-container', {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 24,
      autoplay: {
        disableOnInteraction: false,
        delay: 2000,
      },
    });
  },
  activated() {
  }
});
</script>
<style lang="less" scoped>
.serdiv1{
  padding-top: 50px;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.seritem{
  width: 249px;
  height: 387px;
  border-radius: 8px;
  box-shadow: 0px 0px 6px #3E548229;
  overflow: hidden;
}
.serdiv2{
  background-color: #536dfe;
  position: relative;
  height: 194px;
  overflow: hidden;
}
.serdiv2 img{
  width: 100%;
  height: 100%;
}
.serdiv3{
  text-align: center;
}
.sersp1{
  display: block;
  margin: 22px 0 16px;
  font: normal normal bold 22px Source Han Sans CN;
  letter-spacing: 0px;
  color: #333333;
  opacity: 1;
}
.sersp2{
  display: block;
  /* margin-bottom: 10px; */
  font: normal normal normal 16px/28px Microsoft YaHei;
  letter-spacing: 0px;
  color: #717B81;
  opacity: 1;
}
.serdiv4{
  width: 100%;
  height: 680px;
  background-image: url("../assets/img/bg/9.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  padding-top: 107px;
  text-align: center;
}
.sersp3{
  font: normal normal normal 40px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
  display: block;
  padding-bottom: 30px;
}
.sersp4{
  font: normal normal normal 20px/32px Microsoft YaHei;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
  }
.serdiv5{
  padding-top: 65px;
  width: 888px;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.serdiv6{
  width: 264px;
  height: 226px;
  position: relative;
}
.serdiv6:hover{
  .serdiv8{
    display: block;
    animation: fade-in;/*动画名称*/  
    animation-duration: .4s;/*动画持续时间*/  
    -webkit-animation:fade-in .4s;/*针对webkit内核*/  
  }
}
.serdiv8{
  width: 100%;
  height: 100%;
  border: 3px solid #95B5FF;
  border-radius: 33px;
  position: absolute;
  left: 0;
  right: 0;
  display: none;
}
@keyframes fade-in {  
    0% {opacity: 0;}/*初始状态 透明度为0*/  
    30% {opacity: 0.25;}
    50% {opacity: 0.5;}/*过渡状态 透明度为0*/  
    80% {opacity: 0.75;}
    100% {opacity: 1;}/*结束状态 透明度为1*/  
}  
@-webkit-keyframes fade-in {/*针对webkit内核*/  
    0% {opacity: 0;}  
    30% {opacity: 0.25;}
    50% {opacity: 0.5;}  
    80% {opacity: 0.75;}
    100% {opacity: 1;}  
}  
.serdiv7{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
  .iconfont{
    font-size: 48px;
    display: block;
    color: #ffffff;
    margin-bottom: 22px;
  }
}
.sersp5{
  font: normal normal bold 22px/28px Source Han Sans CN;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
}
.serdiv9{
  padding-top: 107px;
  text-align: left;
}
.sersp6{
  font: normal normal bold 40px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #333333;
  opacity: 1;
  display: block;
  padding-bottom: 34px;
}
.sersp7{
  font: normal normal normal 20px/32px Microsoft YaHei;
  letter-spacing: 0px;
  color: #717B81;
  opacity: 1;
}
.serdiv10{
  padding: 40px 0 90px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
}
.serdiv11{
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 327px;
  margin: 0 auto;
}
.serdiv12{
  text-align: center;
  .iconfont{
    font-size: 48px;
    color: #536DFE;
    display: block;
    margin-bottom: 20px;
  }
  .sersp8{
    font: normal normal bold 22px/28px Source Han Sans CN;
    letter-spacing: 0px;
    color: #333333;
    opacity: 1;
  }
}
.serdiv13{
  padding-top: 50px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.serdiv14{
  text-align: center;
  width: 342px;
  height: 302px;
  box-shadow: 0px 0px 6px #3E548229;
  border-radius: 8px;
  padding-top: 50px;
  .iconfont{
    font-size: 48px;
    color: #536DFE;
    display: block;
  }
  .sersp9{
    display: block;
    margin: 13px 0 20px;
    font: normal normal bold 22px/32px Source Han Sans CN;
    letter-spacing: 0px;
    color: #333333;
    opacity: 1;
  }
  .sersp10{
    font: normal normal normal 15px/28px Microsoft YaHei;
    letter-spacing: 0px;
    color: #717B81;
    opacity: 1;
  }
}

.seritem:hover{
  .serimg{
    animation: showbig;/*动画名称*/  
    animation-duration: .4s;/*动画持续时间*/  
    -webkit-animation:showbig .4s;/*针对webkit内核*/  
    transform: scale(1.4);
  }
  
}
@keyframes showbig {  
    0% {transform: scale(1);}
    25% {transform: scale(1.1);}
    50% {transform: scale(1.2);}
    75% {transform: scale(1.3);}
    100% {transform: scale(1.4);}
}  
@-webkit-keyframes showbig {/*针对webkit内核*/  
    0% {transform: scale(1);}  
    25% {transform: scale(1.1);}
    50% {transform: scale(1.2);}  
    75% {transform: scale(1.3);}
    100% {transform: scale(1.4);}  
}  
</style>
<style scoped>
.audiv1{
  width: 300px;
  text-align: center;
  margin: 0 auto;
  padding-top: 90px;
}
.ausp1{
  display: block;
  text-align: center;
  font: normal normal normal 56px/56px HuXiaoBo-NanShen;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
  padding-bottom: 14px;
}
.ausp2{
  font: normal normal bold 40px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #536DFE;
  opacity: 1;
}
.header {
  background-image: url("../assets/img/bg/4.jpg");
  height: 520px;
  position: relative;
}
.maindiv13{
  padding: 100px 0;
  text-align: center;
}

.maindiv14{
  padding: 0 20px;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  overflow: hidden;
}
.maindiv15{
  width: 127px;
  height: 127px;
  border-radius: 50%;
  margin: 34px 0 12px 0;
  position: relative;
}
.maindiv15:hover{
  cursor: pointer;
  background-color: #ffffff;
}

.maindiv15 img{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.maindiv15::before{
  content: '';
  width: 110px;
  height: 3px;
  background-color: #D8DBEF;
  position: absolute;
  right: -144px;
  top: 50%;
}

.mainsp11{
  font: normal normal bold 22px/30px Source Han Sans CN;
  letter-spacing: 0px;
  color: #333333;
}

.selected{
  border: #536DFE 1px solid;
  background-color: #ffffff;
}

.maindiv16{
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 17px;
  background-color: #ffffff;
  margin-top: 40px;
  padding: 60px 80px;
}
.maindiv17{
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.maindiv18,.maindiv19{
  width: 50%;
}
.maindiv18{
  padding-right: 30px;
}
.maindiv18 img{
  width: 430px;
  height: 240px;
}
.maindiv19{
  padding-left: 30px;
}
.maindiv21{
  box-shadow: 0px 3px 6px #6B8DC829;
  background-color: #ffffff;
  display: inline-block;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 12px;
  position: relative;
}
.mainicon{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  font-size: 16px;
  font-weight: bold;
  color: #536DFE;
}
.mainicon1{
  font-size: 20px;
  color: #C5CAE9;
  position: relative;
  top: 10px;
}
.mainsp12{
  font: normal normal bold 18px/26px Source Han Sans CN;
  letter-spacing: 0px;
  color: #333333;
}
.maindiv22{
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.maindiv20{
  padding: 15px 0 20px;
  text-align: left;
}

.mainsp13{
  font: normal normal normal 15px/28px Microsoft YaHei;
  letter-spacing: 0px;
  color: #717B81;
}
.mainsp8{
  font: normal normal normal 40px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #333333;
  display: block;
  margin-bottom: 28px;
}
.mainsp9{
  font: normal normal normal 18px/32px Microsoft YaHei;
  letter-spacing: 0px;
  color: #717B81;
}
.swiper-container {
  width: 100%;
  height: 490px;
}
.swiper-slide {
  width: 60%;
  width: 84%;
  padding: 45px 8%;
  background: #FFFFFF;
  border-radius: 8px;
  -webkit-box-shadow: 0px 0px 10px #3e548229;
  box-shadow: 0px 0px 10px #3e548229;
  height: 477px;
}
</style>
